 
 <div *ngIf="entreprises">

<app-sous-groupes-create [entreprises]="entreprises"></app-sous-groupes-create>

</div>
